<template>
  <div class="main">
    <div class="content">
      <div class="banner">
        <a href="https://spolalabs.com/blog/2" target="_blank" rel="noopener noreferrer">
          <img src="@/assets/images/banner_m.png" alt="">
        </a>
      </div>
      <div class="section" >
        <div class="section-content">
          <img src="@/assets/images/m_bg2.png" alt="" class="section-bg-1">
          <div class="section-l">
            <img src="@/assets/images/m_pass_card.png" alt="">
          </div>
          <div class="section-r" style="margin-top: -.57rem">
            <p
              class="section-r-sub-title"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Exclusive Collection
            </p>
            <br />
            <p class="section-r-title section-r-title-0" data-aos="fade-up" data-aos-delay="100">
              Spola PASS NFT
            </p>
            <p
              class="section-r-content"
              style="margin-top: 9px"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              The unique digital portrait and the crucial PASS <br />throughout our
              Spola Ecosystem, holders will <br /> receive IRL benefits from it.
            </p>
          </div>
        </div>
        <div class="section-content mt150">
          <img src="@/assets/images/m_bg3.png" alt="" class="section-bg-2">
          <div class="section-rr flex-center-sb" data-aos="fade-up" data-aos-delay="300">
            <img src="@/assets/images/main_section_img1.png" alt=""  />
            <img src="@/assets/images/main_section_img2.png" alt=""  />
            <img src="@/assets/images/main_section_img3.png" alt=""  />
            <div class="section-rr-ft">
              <img src="@/assets/images/indicate.png" alt="" />
            </div>
          </div>
          <!-- <img src="@/assets/images/main_section_img3.png" alt="" class="section-l-img3" data-aos="fade-up" data-aos-delay="300"> -->
          <div class="section-r" style="margin-top: .46rem">
            <p class="section-r-title-1" data-aos="fade-up" data-aos-delay="100">
              Realistic Utility Grants the <br /> Privilege
            </p>
            <p
              class="section-r-content"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              IRL benefits are the core of Spola PASS. We serve <br /> as sports
              managers and capture various rights of <br /> sports management for
              members in real life.
            </p>
            <!-- <p class="section-more" data-aos="fade-up" data-aos-delay="300">
              <span>Learn more</span>
              <img src="@/assets/images/more_arrow.svg" alt="" />
            </p> -->
          </div>
        </div>
      </div>
      <div class="section mt160">
        <div class="title flex-center-center" data-aos="fade-up">
          <img src="@/assets/images/main_title_img_1.png" alt="" />
          <span>You will get</span>
          <img src="@/assets/images/main_title_img_2.png" alt="" />
        </div>
        <div class="section-content section-content-not-after">
          <img src="@/assets/images/m_bg4.png" alt="" class="section-bg-3">
          <div
            class="section-content-box section-content-box-world"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div class="section-r">
              <p
                class="section-r-title"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                World Cup 2022
              </p>
              <p
                class="section-r-content"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                -Ticket including semi-finals/finals<br />-AMA with superstar<br />-Offline
                activity<br />-Signed jersey and photo
              </p>
            </div>
            <img
              src="@/assets/images/main_section_img4.png"
              alt=""
              data-aos="fade-up"
              data-aos-delay="400"
            />
          </div>
          <div
            class="
              section-content-box
              section-content-box-airdrop
            "
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <img
              src="@/assets/images/main_section_img5.svg"
              alt=""
              class="box-bg"
              data-aos="fade-up"
              data-aos-delay="400"
            />
            <div class="box-content">
              <p
                class="section-box-title"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Airdrop
              </p>
              <p
                class="section-box-content"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                -$Spola token airdrop <br />-Collaborative partners token
                airdrop
              </p>
            </div>
          </div>
          <div
            class="
              section-content-box
              section-content-box-priority
            "
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div class="box-content">
              <p
                class="section-box-title"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Priority
              </p>
              <p
                class="section-box-content"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                -Spola originated NFT whitelist and price discount<br />-Founding
                member of club DAO<br />-More...
              </p>
              <img
                src="@/assets/images/main_section_img6.png"
                alt=""
                class="box-img"
                data-aos="fade-up"
                data-aos-delay="400"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section mt304">
        
        <div
          class="title flex-center-center"
          style="margin-bottom: 0"
          data-aos="fade-up"
        >
          <img src="@/assets/images/main_title_img_1.png" alt="" />
          <span>BUT HOW?</span>
          <img src="@/assets/images/main_title_img_2.png" alt="" />
        </div>
        <div class="section-content-1">
          <img src="@/assets/images/m_bg7.png" alt="" class="section-bg-7">
          <div class="section-l" data-aos="fade-up" data-aos-delay="400">
            <img src="@/assets/images/main_section_img7.png" alt="" />
          </div>
          <div class="section-r">
            <p
              class="section-box-title"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Gain Massive IRL Benefit from <br />
              Mystery Box
            </p>
            <p
              class="section-box-content"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              By purchasing a mystery box, you can obtain one <br /> OG PASS with a
              specific level randomly.
            </p>
            <div class="section-btn flex-center-center" data-aos="fade-up" data-aos-delay="400" @click="mint">
              MINT NOW!
            </div>
          </div>
        </div>
      </div>
      <div class="section mt160" style="z-index:1">
        <div class="section-levels vh450">
          <div class="section-sticky vh100-96">
            <img src="@/assets/images/m_bg6.png" alt="" class="section-bg-6">
            <div class="section-levels-hd">
              <div class="section-levels-hd-center">
                <div class="section-levels-hd-l">
                  <p class="flex-center section-levels-hd-title" data-aos="fade-up">
                    <span></span>OG PASS is composed of 4 levels
                  </p>
                  <p class="section-levels-hd-sub-title" data-aos="fade-up" data-aos-delay="200">
                    All the benefits will be allocated to the four levels
                    proportionally.
                  </p>
                  <p class="flex-center levels" data-aos="fade-up" data-aos-delay="200">
                    <span class="flex-start"><span></span> - Platinum</span>
                    <span class="flex-start"><span></span> - Gold</span>
                    <span class="flex-start"><span></span> - Silver</span>
                    <span class="flex-start"><span></span> - Bronze</span>
                  </p>
                </div>
                <div class="section-levels-hd-r">
                  <p class="flex-center section-levels-hd-title" data-aos="fade-up">
                    <span></span>Total supply of 5,000
                  </p>
                  <p class="section-levels-hd-sub-title" data-aos="fade-up" data-aos-delay="200">
                    Round One 4,000，Round Two 1,000.
                  </p>
                </div>
              </div>
            </div>
            <div class="section-main flex-start">
              <div class="section-item">
                <div class="section-item-r">
                  <img
                    data-aos="fade-up" 
                    src="@/assets/images/pass_1.png"
                    alt=""
                  />
                </div>
                <div class="section-item-l">
                  <p class="section-item-title section-item-title-1" data-aos="fade-up" >
                    OG - BRONZE
                  </p>
                  <div class="section-item-l-div flex-center" id="el4" data-aos="fade-up" data-aos-delay="200">
                    <p>Total release <span>3000</span></p>
                    <div class="section-item-p">
                      <div class="section-item-p-a section-item-p-a-1"></div>
                    </div>
                  </div>
                  <div class="section-item-l-div flex-center" data-aos="fade-up" data-aos-delay="400">
                    <p class="flex-center">Holder Benefits:</p>
                    <div class="section-item-l-div-p flex-center">
                      <img src="@/assets/images/icon_1.svg" alt="" />
                      <p><span>$20 SPO</span> token airdrop</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-item">
                <div class="section-item-r">
                  <img
                    data-aos="fade-up" 
                    src="@/assets/images/pass_3.png"
                    alt=""
                  />
                </div>
                <div class="section-item-l">
                  <p class="section-item-title section-item-title-2" data-aos="fade-up" >
                    OG - SILVER
                  </p>
                  <div class="section-item-l-div flex-center" id="el5" data-aos="fade-up" data-aos-delay="200">
                    <p>Total release <span>1500</span></p>
                    <div class="section-item-p">
                      <div class="section-item-p-a section-item-p-a-2"></div>
                    </div>
                  </div>
                  <div class="section-item-l-div flex-center" data-aos="fade-up" data-aos-delay="400">
                    <p class="flex-center">Holder Benefits:</p>
                    <div class="section-item-l-div-p flex-center">
                      <img src="@/assets/images/icon_1.svg" alt="" />
                      <p><span>$50 SPO</span> token airdrop</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-item">
                <div class="section-item-r">
                  <img
                    data-aos="fade-up" 
                    src="@/assets/images/pass_2.png"
                    alt=""
                  />
                </div>
                <div class="section-item-l">
                  <p class="section-item-title section-item-title-3" data-aos="fade-up">OG - GOLD</p>
                  <div class="section-item-l-div flex-center" id="el6" data-aos="fade-up" data-aos-delay="200">
                    <p>Total release <span>350</span></p>
                    <div class="section-item-p">
                      <div class="section-item-p-a section-item-p-a-3"></div>
                    </div>
                  </div>
                  <div class="section-item-l-div flex-start" data-aos="fade-up" data-aos-delay="300">
                    <p class="flex-center">Holder Benefits:</p>
                    <div style="margin-top: .02rem">
                      <div class="section-item-l-div-p flex-center">
                        <img src="@/assets/images/icon_1.svg" alt="" />
                        <p><span>$50 SPO</span> token airdrop</p>
                      </div>
                      <div
                        class="section-item-l-div-p flex-center"
                        style="margin-top: .24rem"
                      >
                        <img src="@/assets/images/icon_2.svg" alt="" />
                        <p><span>Qatar World Cup 2022 Tickets x 1</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-item">
                <div class="section-item-r">
                  <img
                    data-aos="fade-up" 
                    src="@/assets/images/pass_4.png"
                    alt=""
                  />
                </div>
                <div class="section-item-l">
                  <p class="section-item-title section-item-title-4" data-aos="fade-up">OG - PLATINUM</p>
                  <div class="section-item-l-div flex-center" id="el6" data-aos="fade-up" data-aos-delay="200">
                    <p>Total release <span>150</span></p>
                    <div class="section-item-p">
                      <div class="section-item-p-a section-item-p-a-4"></div>
                    </div>
                  </div>
                  <div class="section-item-l-div flex-start" data-aos="fade-up" data-aos-delay="300">
                    <p class="flex-center">Holder Benefits:</p>
                    <div style="margin-top: .02rem">
                      <div class="section-item-l-div-p flex-center">
                        <img src="@/assets/images/icon_1.svg" alt="" />
                        <p><span>$50 SPO</span> token airdrop</p>
                      </div>
                      <div
                        class="section-item-l-div-p flex-center"
                        style="margin-top: .24rem"
                      >
                        <img src="@/assets/images/icon_2.svg" alt="" />
                        <p><span>Signed Jersey</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { throttle } from '../../libs/utils'
export default {
  name: "Main",
  data() {
    return {
      faqIndex: -1,
      el1Count: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      isShow: false,
      rotate: false,
      scrollTop: 0
    };
  },
  created() {
    this.$nextTick(() => {
      console.log(1)
      let viewHeight = window.innerHeight
      let el = document.querySelector('.section-main')
      window.addEventListener('scroll', throttle(() => {
        console.log(2)
        let top = document.querySelector('.section-levels').getBoundingClientRect().top
        if (top < 0) {
          let offset = (-top) / viewHeight
          if (offset > .25 && offset < 3.25) {
            el.style.left = -(offset - .25) * 100 + 'vw'
          } else if (offset < .25) {
            el.style.left = 0
          } else {
            el.style.left = -300 + 'vw'
          }
        } else if (top > 0) {
          el.style.left = 0
        }
      }, 0), false)
    })
  },
  methods: {
    mint() {
      this.$emit('mint')
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  font-size: 0;
  text-align: center;
  z-index: 9;
  .banner {
    position: relative;
    z-index: 9;
    margin-top: .55rem;
    margin-bottom: .3rem;
    a {
      display: inline-block;
    }
    img {
      width: 100%;
      height: auto;
      margin: auto;
    }
  }
  .section {
    position: relative;
    z-index: 2;
    .title {
      margin-bottom: .6rem;
      img {
        width: .15rem;
        height: auto;
      }
      span {
        font-size: .32rem;
        font-family: DINPro-Bold, DINPro;
        color: #FFFFFF;
        line-height: .41rem;
        margin-left: .20rem;
        margin-right: .20rem;
        text-transform: uppercase;
      }
    }
    .section-content {
      width: 100%;
      padding-bottom: .5rem;
      box-sizing: border-box;
      position: relative;
      &::after {
        position: absolute;
        z-index: -1;
        content: '';
        left: .45rem;
        right: .45rem;
        bottom: 0;
        top: 2.2rem;
        background: #171619;
        border-radius: .34rem;
        opacity: 0.6;
      }
      &.section-content-not-after {
        &::after {
          display: none;
        }
      }
      .section-bg-1 {
        position: absolute;
        bottom: -.09rem;
        left: 0;
        right: 0;
        width: 100%;
        height: auto;
        z-index: -2;
      }
      .section-bg-2 {
        position: absolute;
        top: 1.9rem;
        left: 0;
        right: 0;
        width: 100%;
        height: auto;
        z-index: -2;
      }
      .section-bg-3 {
        position: absolute;
        bottom: .8rem;
        left: 0;
        right: 0;
        width: 100%;
        height: auto;
        z-index: -2;
      }
      .section-l {
        position: relative;
        width: 100%;
        img {
          width: 6.12rem;
          height: auto;
          margin: auto;
        }
      }
      .section-r {
        text-align: center;
        position: relative;
        .section-r-sub-title {
          display: inline-block;
          font-size: .24rem;
          font-family: DINPro-Regular, DINPro;
          font-weight: 400;
          color: #778AA2;
          line-height: .31rem;
          background: linear-gradient(299deg, #1C42FF 0%, #4BE9F2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .section-r-title {
          display: inline-block;
          margin-top: .12rem;
          font-size: .32rem;
          font-family: DINPro-Bold, DINPro;
          color: #FFFFFF;
          line-height: .41rem;
          background: linear-gradient(299deg, #1C42FF 0%, #4BE9F2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-transform: uppercase;
          &.section-r-title-0 {
            background: linear-gradient(295deg, #1C42FF 0%, #4BE9F2 50%, #CBFFEC 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .section-r-title-1 {
          display: inline-block;
          font-size: .32rem;
          font-family: DINPro-Bold, DINPro;
          color: #FFFFFF;
          line-height: .41rem;
          background: linear-gradient(303deg, #1C42FF 0%, #4BE9F2 89%, #CBFFEC 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-transform: uppercase;

        }
        .section-r-content {
          font-size: .24rem;
          font-family: DINPro-Regular, DINPro;
          font-weight: 400;
          color: #778AA2;
          line-height: .40rem;
          margin-top: .12rem;
          padding: 0 .56rem;
        }
        .section-more {
          margin-top: .39rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          span {
            font-size: .24rem;
            font-family: DINPro-Bold, DINPro;
            color: #1C42FF;
            line-height: .32rem;
            background: linear-gradient(301deg, #1C42FF 0%, #4BE9F2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          img {
            width: .1rem;
            margin-left: .12rem;
            position: relative;
            left: 0;
            transition: all 0.3s;
            margin-top: .04rem;
          }
          &:hover {
            img {
              left: 8px;
            }
          }
        }
      }
      .section-rr {
        width: 100%;
        position: relative;
        padding: 0 1.17rem;
        box-sizing: border-box;
        img {
          width: 1.61rem;
          height: auto;
          opacity: 0.6;
          transition: all .25s linear;
        }
        .section-rr-ft {
          position: absolute;
          bottom: 0;
          right: 1.17rem;
          left: 1.17rem;
          transition: all .25s linear;
          height: 1px;
          background: linear-gradient(
            299deg,
            rgba(110, 195, 255, 1),
            rgba(28, 66, 255, 0)
          );
          img {
            position: absolute;
            right: -.17rem;
            bottom: 0;
            width: 1.39rem;
            height: auto;
            opacity: 1;
          }
          &::after {
            content: "";
            width: .08rem;
            height: .08rem;
            border-radius: .08rem;
            background: #6ec3ff;
            position: absolute;
            right: -.04rem;
            top: -.03rem;
          }
        }
      }
      .section-content-box {
        width: 6.6rem;
        margin: auto;
        background: rgba($color: #171619, $alpha: 0.6);
        border-radius: 34px;
        padding-top: .33rem;
        position: relative;
        padding-bottom: 1.72rem;
        img {
          width: 7.03rem;
          position: absolute;
          left: -.06rem;
          bottom: -1.33rem;
          height: auto;
          transition: all 0.3s;
        }
        &.section-content-box-airdrop,
        &.section-content-box-priority {
          margin-top: 2.18rem;
          padding-top: .26rem;
          padding-bottom: 1.85rem;
          box-sizing: border-box;
          position: relative;
          .box-bg {
            width: 5.32rem;
            height: auto;
            position: absolute;
            top: -.26rem;
            left: .65rem;

          }
          .section-box-title {
            font-size: .32rem;
            font-family: DINPro-Bold, DINPro;
            color: #FFFFFF;
            line-height: .41rem;
            background: linear-gradient(305deg, #1C42FF 0%, #4BE9F2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            text-transform: uppercase;
          }
          .section-box-content {
            font-size: .24rem;
            font-family: DINPro-Regular, DINPro;
            font-weight: 400;
            color: #778AA2;
            line-height: .40rem;
            margin-top: .12rem;
          }
        }
        &.section-content-box-priority {
          padding-bottom: 1.45rem;
          .box-img {
            margin-top: .26rem;
            width: 5.16rem;
            height: auto;
            position: absolute;
            bottom: -1.44rem;
            left: .72rem;
          }
        }
      }
    }
    .section-content-1 {
      position: relative;
      margin-top: .59rem;
      .section-bg-7 {
        position: absolute;
        top: .08rem;
        left: 0;
        right: 0;
        width: 100%;
        height: auto;
      }
      .section-l {
        img {
          width: 4.7rem;
          height: auto;
        }
      }
      .section-r {
        margin-top: .59rem;
        text-align: center;
        .section-box-title {
          font-size: .32rem;
          font-family: DINPro-Bold;
          color: #FFFFFF;
          line-height: .41rem;
          background: linear-gradient(299deg, #1C42FF 0%, #4BE9F2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-transform: uppercase;
          display: inline-block;
        }
        .section-box-content {
          font-size: .24rem;
          font-family: DINPro-Regular, DINPro;
          font-weight: 400;
          color: #778AA2;
          line-height: .40rem;
          margin-top: .12rem;
        }
        .section-btn {
          margin: auto;
          margin-top: .6rem;
          width: 4.06rem;
          height: .56rem;
          background: linear-gradient(132deg, #FF4747 0%, #B500FF 52%, #1C42FF 100%);
          border-radius: .16rem;
          font-size: .24rem;
          font-family: DINPro-Bold, DINPro;
          color: #FFFFFF;
        }
      }
    }
    .section-levels {
      .section-sticky {
        z-index: 99;
        position: sticky;
        top: .96rem;
        overflow: hidden;
      }
      .section-bg-6 {
        position: absolute;
        z-index: -1;
        left: 0;
        right: 0;
        width: 100%;
        height: auto;
        top: -13rem;
      }
      .section-levels-hd {
        transition: all .35s;
        padding: .24rem .45rem 0;
        box-sizing: border-box;
        .section-levels-hd-center {
          margin: auto;
          justify-content: space-between;
        }
        .section-levels-hd-title {
          font-size: .24rem;
          font-family: DINPro-Bold, DINPro;
          font-weight: bold;
          color: #778AA2;
          line-height: .32rem;
          text-transform: uppercase;
          span {
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 3px;
            background: #778aa2;
            margin-right: 12px;
          }
        }
        .section-levels-hd-sub-title {
          margin-top: .12rem;
          font-size: .24rem;
          color: #778AA2;
          line-height: .40rem;
          text-align: left;
          white-space: nowrap;
        }
        .section-levels-hd-l {
          p {
            &:nth-child(3) {
              span {
                font-size: .24rem;
                font-family: DINPro-Regular, DINPro;
                font-weight: 400;
                color: #A7E3FD;
                line-height: .32rem;
                margin-right: .30rem;
                span {
                  margin-top: .10rem;
                  margin-right: .04rem;
                  width: .16rem;
                  height: .16rem;
                  border-radius: .08rem;
                }
                &:nth-child(1) {
                  color: #a7e3fd;
                  span {
                    background: #a7e3fd;
                  }
                }
                &:nth-child(2) {
                  color: #f4d762;
                  span {
                    background: #f4d762;
                  }
                }
                &:nth-child(3) {
                  color: #e6e6e6;
                  span {
                    background: #e6e6e6;
                  }
                }
                &:nth-child(4) {
                  color: #fa9d76;
                  span {
                    background: #fa9d76;
                  }
                }
              }
            }
          }
        }
        .section-levels-hd-r {
          margin-top: .54rem;
          .section-levels-hd-r-item {
            margin-top: 14px;
            p {
              font-size: 20px;
              font-weight: 400;
              color: #778aa2;
              line-height: 32px;
            }
            .section-levels-hd-r-p {
              margin-left: 21px;
              width: 274px;
              height: 3px;
              background: rgba($color: #778aa2, $alpha: 0.5);
              border-radius: 2px;
              position: relative;
              .section-levels-hd-r-p-a {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                background: #778aa2;
                border-radius: 2px;
                width: 0;
                transition: all .75s;
              }
            }
          }
        }
      }
      .section-main {
        margin-top: 1.23rem;
        white-space: nowrap;
        position: relative;
        transition-timing-function: linear;
        // left: -300vw;
        .section-item {
          width: 100vw;
          flex: 0 0 100vw;
          padding: 0 .45rem;
          box-sizing: border-box;
          .section-item-l {
            text-align: left;
            margin-top: 1.3rem;
            .section-item-title {
              font-size: .32rem;
              font-family: DINPro-Bold, DINPro;
              color: #778AA2;
              line-height: 1;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              &.section-item-title-1 {
                background: linear-gradient(295deg, #f09256 0%, #cbffec 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.section-item-title-2 {
                background: linear-gradient(295deg, #ffffff 0%, #cbffec 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.section-item-title-3 {
                background: linear-gradient(295deg, #f2ce2b 0%, #cbffec 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.section-item-title-4 {
                background: linear-gradient(295deg, #0495ff 0%, #cbffec 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .section-item-l-div {
              margin-top: .46rem;
              & ~ .section-item-l-div {
                margin-top: .24rem;
              }
              p {
                font-size: .24rem;
                color: #778AA2;
                line-height: .32rem;
                span {
                  font-family: DINPro-Bold;
                }
              }
              .section-item-p {
                margin-left: .24rem;
                width: 4.37rem;
                height: .03rem;
                background: rgba($color: #778aa2, $alpha: 0.5);
                border-radius: .02rem;
                position: relative;
                .section-item-p-a {
                  position: absolute;
                  left: 0;
                  top: 0;
                  bottom: 0;
                  height: .03rem;
                  border-radius: .02rem;
                  width: 0;
                  transition: all .75s;
                  &.section-item-p-a-1 {
                    background: linear-gradient(
                      295deg,
                      #f09256 0%,
                      #cbffec 100%
                    );
                    width: 3.29rem;
                  }
                  &.section-item-p-a-2 {
                    background: linear-gradient(
                      295deg,
                      #ffffff 0%,
                      #cbffec 100%
                    );
                    width: 1.69rem;
                  }
                  &.section-item-p-a-3 {
                    background: linear-gradient(295deg, #F2CE2B 0%, #CBFFEC 100%);
                    width: .9rem;
                  }
                  &.section-item-p-a-4 {
                    background: linear-gradient(295deg, #0C98FF 0%, #CBFFEC 100%);
                    width: .29rem;
                  }
                }
              }
              .section-item-l-div-p {
                margin-left: .24rem;
                img {
                  width: .28rem;
                  height: .28rem;
                }
                p {
                  margin-left: .12rem;
                  font-size: .24rem;
                  color: #778AA2;
                  line-height: .32rem;
                  background: linear-gradient(295deg, #1C42FF 0%, #4BE9F2 50%, #CBFFEC 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  span {
                    font-family: DINPro-Bold, DINPro;
                  }
                }
              }
            }
            .section-item-l-img {
              margin-top: 22px;
              width: 421px;
              height: auto;
            }
          }
          .section-item-r {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 4.19rem;
            img {
              height: auto;
              width: 5.64rem;
            }
          }
        }
      }
    }
  }
}
.mt150 {
  margin-top: 1.5rem;
}
.mt160 {
  margin-top: 1.6rem;
}
.mt304 {
  margin-top: 3.04rem;
}
.vh100-96 {
  height: calc(100vh - .96rem) !important;
}
.vh450 {
  height: 450vh !important;
}
@keyframes myRotate {
  0% {
    transform: rotate(90deg) scale(0);
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
}
@keyframes myRotate1 {
  0% {
    transform: rotate(360deg) scale(1);
  }
  2.5% {
    transform: rotate(315deg) scale(0.85);
  }
  5% {
    transform: rotate(270deg) scale(1);
  }
  25% {
    transform: rotate(270deg) scale(1);
  }
  27.5% {
    transform: rotate(225deg) scale(0.85);
  }
  30% {
    transform: rotate(180deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(1);
  }
  52.5% {
    transform: rotate(135deg) scale(0.85);
  }
  55% {
    transform: rotate(90deg) scale(1);
  }
  75% {
    transform: rotate(90deg) scale(1);
  }
  77.5% {
    transform: rotate(45deg) scale(0.85);
  }
  80% {
    transform: rotate(0deg) scale(1);
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
}

@keyframes float1 {
  0% {
    transform: translateY(0px) scale(1);
  }
  66% {
    transform: translateY(-10px) scale(1.01);
  }
  100% {
    transform: translateY(-10px) scale(1.05);
  }
}

@keyframes float2 {
  0% {
    transform: translateY(0px) scale(1);
  }
  25% {
    transform: translateY(10px) scale(1);
  }
  50% {
    transform: translateY(0px) scale(1);
  }
  75% {
    transform: translateY(-10px) scale(1);
  }
  100% {
    transform: translateY(0px) scale(1);
  }
}

@keyframes float3 {
  0% {
    transform: translateY(0px) translateX(0);
  }
  50% {
    transform: translateY(10px) translateX(-10px);
  }
  0% {
    transform: translateY(0px) translateX(0);
  }
}
</style>